export default "__VITE_ASSET__BHG1iA29__"